<template>
  <v-alert
    class="acs-base-empty-list mx-4"
    dense
    outlined
    color="grey"
    :value="value"
  >
    <v-icon
      size="80"
      :color="colour"
    >
      mdi-format-list-checkbox
    </v-icon>
    <br>
    {{ text }}
  </v-alert>
</template>

<script>
export default {
  name: 'ElacSharedEmptyList',

  props: {
    value: { type: Boolean },
    text: { type: String, default: '' },
    colour: { type: String, default: 'grey lighten-2' },
  },
};
</script>
